export const useCaptureError = ({ code, error }) => {
  const { $gaApp } = useNuxtApp()

  const newError = new Error(`Страница ошибки ${code}` + (error?.message ?? ''))
  newError.dataError = JSON.stringify(error || {})
  newError.name = 'Page Error ' + code + (error?.message ?? '')

  const captureError = () => {
    $gaApp.services.app.apm.captureError(newError)
  }

  return {
    captureError,
  }
}
